import OverviewBase from "@pages/payroll/payslip/overview/OverviewBase";
import { getTotalOverviewSections } from "@pages/payroll/payslip/overview/TotalOverview.utils";
import memoizeOne from "@utils/memoizeOne";
import i18next from "i18next";

import { getEntityETag } from "../../../../views/formView/Form.utils";

export default class TotalOverview extends OverviewBase {

    _hasPinkBackground = true;
    _title = i18next.t("Payslip:Form.UpdateCalculations");
    _isEditable = false;

    getSections = memoizeOne(() => {
        return getTotalOverviewSections(this.props.storage);
    }, () => ([getEntityETag(this.props.storage)]));
}
